import {
    StringSelectMenuBuilder as DiscordStringSelectMenuBuilder,
    UserSelectMenuBuilder as DiscordUserSelectMenuBuilder,
    RoleSelectMenuBuilder as DiscordRoleSelectMenuBuilder,
    ChannelSelectMenuBuilder as DiscordChannelSelectMenuBuilder,
    MentionableSelectMenuBuilder as DiscordMentionableSelectMenuBuilder,
    StringSelectMenuComponentData,
    APIStringSelectComponent,
    UserSelectMenuComponentData,
    APIUserSelectComponent,
    RoleSelectMenuComponentData,
    APIRoleSelectComponent,
    ChannelSelectMenuComponentData,
    APIChannelSelectComponent,
    MentionableSelectMenuComponentData,
    APIMentionableSelectComponent,
} from "discord.js"

export class StringSelectMenuBuilder extends DiscordStringSelectMenuBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<StringSelectMenuComponentData> | Partial<APIStringSelectComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}

export class UserSelectMenuBuilder extends DiscordUserSelectMenuBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<UserSelectMenuComponentData> | Partial<APIUserSelectComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}

export class RoleSelectMenuBuilder extends DiscordRoleSelectMenuBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<RoleSelectMenuComponentData> | Partial<APIRoleSelectComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}

export class ChannelSelectMenuBuilder extends DiscordChannelSelectMenuBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<ChannelSelectMenuComponentData> | Partial<APIChannelSelectComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}

export class MentionableSelectMenuBuilder extends DiscordMentionableSelectMenuBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<MentionableSelectMenuComponentData> | Partial<APIMentionableSelectComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}